<div class="reviews-analysis-container">
  <div class="d-flex flex-column w-100">
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span class="widget-title"> {{ 'csa.clicks.on.google.title' | translate }}</span>
        <span *ngIf="!loading && totalCount" class="widget-sub-title">{{ 'csa.clicks.on.google.subtitle' | translate }}: {{ totalCount }}</span>
      </div>
      <info-tooltip [tooltipText]="'csa.clicks.on.google.tooltip' | translate"></info-tooltip>
    </div>

    <!--------------------- Loading ------------------->
    <csa-progress-save-spinner *ngIf="loading" class="m-auto" [size]="87" [centered]="true" [strokeWidth]="6"></csa-progress-save-spinner>

    <!---------------- Average Rating ready ----------------->
    <ng-container *ngIf="!loading && googleMetrics && googleMetrics.metrics.length">
      <div echarts [options]="chartData" id="click-chart"></div>
    </ng-container>

    <!------------------ No Average Ratings ------------------>
    <ng-container *ngIf="!loading && (!googleMetrics || !googleMetrics?.metrics.length) && !dataCheckFailed">
      <div class="no-data">
        {{ 'csa.reviews.analysis.no-data' | translate }}
      </div>
      <div class="info-text">
        {{ 'csa.clicks.on.google.nodata.text' | translate }}
      </div>
    </ng-container>

    <!------------------ Loading Error ------------------>
    <ng-container *ngIf="!loading && dataCheckFailed">
      <div class="no-data">
        {{ 'csa.reviews.analysis.error' | translate }}
      </div>
      <div class="info-text">
        {{ 'csa.reviews.analysis.error-text' | translate }}
      </div>
      <span class="details" (click)="retry()"> {{ 'csa.reviews.analysis.refresh' | translate }}</span>
    </ng-container>
  </div>
</div>
